export const environment = {
  production: true,
  mixpanelToken: '5cc81cb3e3810770b70f0479465a1c3c',
};
